/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DueState } from './DueState';
import {
    DueStateFromJSON,
    DueStateFromJSONTyped,
    DueStateToJSON,
} from './DueState';
import type { JobFrequency } from './JobFrequency';
import {
    JobFrequencyFromJSON,
    JobFrequencyFromJSONTyped,
    JobFrequencyToJSON,
} from './JobFrequency';
import type { JobState } from './JobState';
import {
    JobStateFromJSON,
    JobStateFromJSONTyped,
    JobStateToJSON,
} from './JobState';
import type { MedicalSystemCatalogDto } from './MedicalSystemCatalogDto';
import {
    MedicalSystemCatalogDtoFromJSON,
    MedicalSystemCatalogDtoFromJSONTyped,
    MedicalSystemCatalogDtoToJSON,
} from './MedicalSystemCatalogDto';

/**
 * 
 * @export
 * @interface JobOccurrenceFilterOptionsDto
 */
export interface JobOccurrenceFilterOptionsDto {
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    id?: number;
    /**
     * 
     * @type {Array<MedicalSystemCatalogDto>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    targetSystems?: Array<MedicalSystemCatalogDto> | null;
    /**
     * 
     * @type {Array<JobFrequency>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    recurrences?: Array<JobFrequency> | null;
    /**
     * 
     * @type {Array<JobState>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    states?: Array<JobState> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    assignedUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    assignedRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<DueState>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    dueStates?: Array<DueState> | null;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    reviewsRequired?: Array<boolean> | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceFilterOptionsDto
     */
    $type?: JobOccurrenceFilterOptionsDtoTypeEnum;
}


/**
 * @export
 */
export const JobOccurrenceFilterOptionsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoJobOccurrenceFilterOptionsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.JobOccurrenceFilterOptionsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type JobOccurrenceFilterOptionsDtoTypeEnum = typeof JobOccurrenceFilterOptionsDtoTypeEnum[keyof typeof JobOccurrenceFilterOptionsDtoTypeEnum];


/**
 * Check if a given object implements the JobOccurrenceFilterOptionsDto interface.
 */
export function instanceOfJobOccurrenceFilterOptionsDto(value?: unknown): value is JobOccurrenceFilterOptionsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(JobOccurrenceFilterOptionsDtoTypeEnum)[0];
}

export function JobOccurrenceFilterOptionsDtoFromJSON(json: any): JobOccurrenceFilterOptionsDto {
    return JobOccurrenceFilterOptionsDtoFromJSONTyped(json, false);
}

export function JobOccurrenceFilterOptionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobOccurrenceFilterOptionsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'targetSystems': !exists(json, 'targetSystems') ? undefined : (json['targetSystems'] === null ? null : (json['targetSystems'] as Array<any>).map(MedicalSystemCatalogDtoFromJSON)),
        'recurrences': !exists(json, 'recurrences') ? undefined : (json['recurrences'] === null ? null : (json['recurrences'] as Array<any>).map(JobFrequencyFromJSON)),
        'states': !exists(json, 'states') ? undefined : (json['states'] === null ? null : (json['states'] as Array<any>).map(JobStateFromJSON)),
        'assignedUserIds': !exists(json, 'assignedUserIds') ? undefined : json['assignedUserIds'],
        'assignedRoleIds': !exists(json, 'assignedRoleIds') ? undefined : json['assignedRoleIds'],
        'dueStates': !exists(json, 'dueStates') ? undefined : (json['dueStates'] === null ? null : (json['dueStates'] as Array<any>).map(DueStateFromJSON)),
        'reviewsRequired': !exists(json, 'reviewsRequired') ? undefined : json['reviewsRequired'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function JobOccurrenceFilterOptionsDtoToJSON(value?: JobOccurrenceFilterOptionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'targetSystems': value.targetSystems === undefined ? undefined : (value.targetSystems === null ? null : (value.targetSystems as Array<any>).map(MedicalSystemCatalogDtoToJSON)),
        'recurrences': value.recurrences === undefined ? undefined : (value.recurrences === null ? null : (value.recurrences as Array<any>).map(JobFrequencyToJSON)),
        'states': value.states === undefined ? undefined : (value.states === null ? null : (value.states as Array<any>).map(JobStateToJSON)),
        'assignedUserIds': value.assignedUserIds,
        'assignedRoleIds': value.assignedRoleIds,
        'dueStates': value.dueStates === undefined ? undefined : (value.dueStates === null ? null : (value.dueStates as Array<any>).map(DueStateToJSON)),
        'reviewsRequired': value.reviewsRequired,
        '$type': value.$type,
    });
}

